// extracted by css-extract-rspack-plugin
export default {"visuallyHidden":"tcwc3mizV3Yvl2Ki"};